import React, { useState } from 'react';
import Seller from '../seller';
import SellerPage from './page';
import HomePage from './HomePage';
import DashboardPage from './DashboardPage';
import SellorSidebar from "./SellorSidebar"; // 대시보드 페이지 임포트

export default function ProductsSeller() {
  const [activePage, setActivePage] = useState('sellerPage'); // 초기 활성 페이지 설정

  const handlePageChange = (page: string) => {
    setActivePage(page);
  };

  return (
    <section className="max-w-[2560px] w-full min-h-screen h-full mx-auto mt-[90px]">
      <div className="flex h-full">
        <div className="w-64 h-full fixed top-[90px]"> {/* Sidebar 고정 */}
          <SellorSidebar onMenuItemClick={handlePageChange} />
        </div>
        <div className="ml-64 w-full h-full overflow-y-auto p-8"> {/* Content에 스크롤 추가 */}
          {activePage === 'sellerPage' && <HomePage />}
          {activePage === 'dashboard' && <DashboardPage />}
          {activePage === 'store' && <Seller />}
          {activePage === 'shop' && <SellerPage />}
        </div>
      </div>
    </section>
  );
}
